export function antiForgeryPost(url, options){
    let opts = {
        method: 'POST',
        ...(options || {})
    };

    if(smartPak.pageData && smartPak.pageData.antiForgeryToken){
        opts.headers = {
            ...opts.headers,
            'x-requestverificationtoken': smartPak.pageData.antiForgeryToken
        };
    }

    return fetch(url, opts);
}
